import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { gsap } from 'gsap';
import paperAirPlane from 'assets/img/landing-page/paper_airplane.glb';

const ThreeDScene = () => {
  const containerRef = useRef(null);
  const arrPositionModel = [
    {
      id: 'banner',
      position: { x: -0.5, y: -0.3, z: 0.2 },
      rotation: { x: 0.2, y: 3.25, z: 0 }
    },
    {
      id: 'intro',
      position: { x: -1, y: -0.3, z: 0.3 },
      rotation: { x: 0.3, y: 3, z: 0 }
    },
    {
      id: 'description',
      position: { x: -0.5, y: -0.3, z: 0.4 },
      rotation: { x: 0.3, y: 3.5, z: 0 }
    },
    {
      id: 'contact',
      position: { x: -0.2, y: -0.3, z: 0.5 },
      rotation: { x: 0.3, y: 3, z: 0 }
    }
  ];
  const camera = new THREE.PerspectiveCamera(
    10,
    window.innerWidth / window.innerHeight,
    0.1,
    1000
  );
  camera.position.z = 8; //13

  const scene = new THREE.Scene();
  const loader = new GLTFLoader();
  useEffect(() => {
    let airplane;

    loader.load(paperAirPlane, gltf => {
      airplane = gltf.scene;
      airplane.position.x = -1;
      airplane.position.y = 0;
      airplane.position.z = -1;
      airplane.rotation.x = 0.2;
      airplane.rotation.y = 3.5;
      airplane.rotation.z = 0;

      scene.add(airplane);
    });

    const renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    containerRef.current.appendChild(renderer.domElement);

    const ambientLight = new THREE.AmbientLight(0xffffff, 1.3);
    scene.add(ambientLight);

    const topLight = new THREE.DirectionalLight(0xffffff, 1);
    topLight.position.set(500, 500, 500);
    scene.add(topLight);

    const reRender3D = () => {
      requestAnimationFrame(reRender3D);
      renderer.render(scene, camera);
      // if (mixer) mixer.update(0.02);
    };
    reRender3D();

    const modelMove = () => {
      const sections = document.querySelectorAll('.section');
      let currentSection;
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 1.8) {
          currentSection = section.id;
        }
      });

      let position_active = arrPositionModel.findIndex(
        val => val.id === currentSection
      );

      if (position_active >= 0) {
        let new_coordinates = arrPositionModel[position_active];
        gsap.to(airplane.position, {
          x: new_coordinates.position.x,
          y: new_coordinates.position.y,
          z: new_coordinates.position.z,
          duration: 3,
          ease: 'power1.out'
        });
        gsap.to(airplane.rotation, {
          x: new_coordinates.rotation.x,
          y: new_coordinates.rotation.y,
          z: new_coordinates.rotation.z,
          duration: 3,
          ease: 'power1.out'
        });
      }
    };

    window.addEventListener('scroll', () => {
      if (airplane) {
        modelMove();
      }
    });

    window.addEventListener('resize', () => {
      renderer.setSize(window.innerWidth, window.innerHeight);
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
    });

    return () => {
      window.removeEventListener('scroll', modelMove);
      window.removeEventListener('resize', () => {
        renderer.setSize(window.innerWidth, window.innerHeight);
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
      });
    };
  }, []);

  return <div id="container3D" ref={containerRef} />;
};

export default ThreeDScene;
